import { getApiUrl, tokenInterceptor, paramsSerializer } from '@app/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const resultsStatsApi = createApi({
  reducerPath: 'resultsStatsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/stats'),
    prepareHeaders: tokenInterceptor,
    paramsSerializer,
  }),
  tagTypes: ['ResultsStats'],
  endpoints: (builder) => ({
    resultsStats: builder.mutation({
      query: (obj) => ({
        url: `results`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
      }),
      providesTags: ['ResultsStats'],
    }),
  }),
});

export const { useResultsStatsMutation } = resultsStatsApi;
